import angular from 'angular';
import '../core/data-access/globalSettings.data-access';

(function() {
    'use strict';
    angular.module('app.global_setting').factory('GlobalSettingSvc', GlobalSettingSvc);

     GlobalSettingSvc.$inject = ['GlobalSettingDA'];

    /* @ngInject */
    function GlobalSettingSvc(GlobalSettingDA) {
        var exports = {
            saveGlobalSetting: saveGlobalSetting,
            getAllGlobalSetting: getAllGlobalSetting
        };

        return exports;

        function saveGlobalSetting(globalSettings){
            return GlobalSettingDA.saveGlobalSetting(globalSettings);
        }
        function getAllGlobalSetting() {
            return  GlobalSettingDA.getAllGlobalSetting();
        }
    }

})();
